// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marketPage[data-v-eca1d488]{position:relative}.tabs svg[data-v-eca1d488]{margin-right:.5rem}.pageHeader__right a[data-v-eca1d488]{border:1px solid;border-radius:1rem;color:#715a30;display:block;line-height:1;padding:.5rem 1rem;-webkit-text-decoration:none;text-decoration:none}.pageHeader__right a svg[data-v-eca1d488]{margin-left:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
